module.exports = __webpack_public_path__ + "images/rich_heading/other/fountain_pen/icon_6b232eefb4b3264fcbc2e1bd928dfde4.png";